/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Paywall_DemoInputs */

const en_mobile_paywall_demo = /** @type {(inputs: Mobile_Paywall_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paywall demo`)
};

const es_mobile_paywall_demo = /** @type {(inputs: Mobile_Paywall_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo de paywall`)
};

/**
* | output |
* | --- |
* | "Paywall demo" |
*
* @param {Mobile_Paywall_DemoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_paywall_demo = /** @type {((inputs?: Mobile_Paywall_DemoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Paywall_DemoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_paywall_demo(inputs)
	return en_mobile_paywall_demo(inputs)
});